import api from '../../helpers/api';

export const getUser = (id) =>
  api.post(`users/get-single-user`, { userID: id });

export const getUsers = (body) => api.post('users/search-users', { ...body });

export const createUser = (body) => api.post('users', { ...body });

export const updateUser = (id, body) => api.put(`users/${id}`, { ...body });

export const updateProfile = (id, body) =>
  api.put(`users/update-profile/${id}`, { ...body });

export const updateUserSettings = (id, body) => 
  api.put(`users/update-user-settings/${id}`, { ...body });

export const checkEmailExist = (body) =>
  api.post('users/check-user-email', body );

export const checkUsernameExist = (body) =>
  api.post('users/check-user-username', body );


export const changePassword = (body) => api.post('auth/reset-password', {...body})

// export const UpdateUder
